// extracted by mini-css-extract-plugin
module.exports = {"legalText":"styles_legalText__GaqbJ"};